export class InterfaceElementTypes {
  /*Form Types*/
  public static readonly FormEntity = '44f844a3-141d-4acf-b672-2e6251fa95ff';
  public static readonly UXController = 'c59ace01-f27e-4815-9a45-68487bba14c7';
  public static readonly ListUXController = '8235d297-3451-4ce2-8d30-a5b2f1f8aa19';
  public static readonly ListSubUXController = '1ff743da-f13c-45af-979c-08d7490cf899';
  public static readonly Wizard = '9c06cce3-d056-47c5-9c79-25adb09c5561';
  public static readonly Groups = '8d957356-d999-41d9-bb63-8d9ed3c37b39';
  public static readonly Group = 'ba7d96f7-139c-4ff0-81f2-022f54d59a49';

  /*Element Types*/
  public static readonly InputText = 'ef5140c5-5e33-42d1-908f-5b9c7673d076';
  public static readonly InputNumber = 'f29c2afa-f53c-464b-8005-9f8dcd7b1d07';
  public static readonly InputDate = '335c80e8-85ea-4428-b142-32cd48f2a837';
  public static readonly InputBoolean = 'd4e2dab0-1a6d-4f2e-a78c-1eac167d0bfb';
  public static readonly InputPicklist = '85755da6-b68b-41b5-a1e0-7d26bfe1b3d0';
  public static readonly InputValuePicklist = 'eab0e9a1-2b77-42fa-9163-d064d8b30b08';
  public static readonly InputSearch = 'ae7d2738-9af1-4926-9886-18a9522c8eca';
  public static readonly Trigger = 'f3ff4425-43bc-4009-809b-fe90129d6d6c';
  public static readonly Label = 'e8086a0f-2c7b-4cfe-82e6-5816858148e3';
  public static readonly Tab = '90685da6-b68b-41b5-a1e0-7d26bfe1b3d0';
  public static readonly Chart = '91686da6-b68b-41b5-a1e0-7d26bfe1b378';
  public static readonly EntityTree = 'a23fedc2-4042-4f15-8e10-e0f24bce2e3c';
  public static readonly CollectionTree = 'da661b41-e50b-4f2a-8485-64a91f0a1392';
  public static readonly AppMapPathSearch = 'e79ff017-14ab-4922-a598-fa09797a56c2';
  public static readonly BreadCrumb = 'e3ed5dd1-79f0-4a5c-9141-db83bf516cbc';
  public static readonly LanguageSelector = 'd86fe6a6-832b-41c5-9335-aba83b3adb48';
  public static readonly Ribbon = 'f6dbcff6-7b68-460b-b5d4-001e66fba0b6'
  
  // public static readonly PDFViewer = 'cosyDocument';

  /*List*/
  public static readonly EntityList = 'e9b199e1-7729-40d7-81dc-d947eb70648f';
  public static readonly MenuList = '634698af-765d-43aa-940c-32d13a03fa82';
  public static readonly CentralMenuList = 'a447c101-4c8d-4ec1-8ea0-bf0bad146dbb';
  public static readonly ControllerID = '10000000-0000-0000-0000-000000000001';
}
